import { Injectable } from '@angular/core';
import { SurveyService } from './survey.service';
import { StringUtils } from '@tangilla/tg-ng-common';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  constructor(private surveyService: SurveyService) {
  }

  get searchOfficeType() {
    return this.getVariable('v-search-office-type');
  }

  get state() {
    return this.getVariable('v-state');
  }

  get associationNrdsId() {
    return this.getVariable('v-association_nrds');
  }

  get staffOffice() {
    return this.getVariable('v-staff-office');
  }

  get officeValidated() {
    return this.getVariable('office_validated');
  }

  set officeValidated(value: any) {
    this.setVariable('office_validated', value);
  }

  set licenseAffiliationsEnabled(value: any) {
    this.setVariable('license_affiliations_enabled', value);
  }

  get totalCharges() {
    return this.getVariable('totalcharge');
  }

  get totalChargesFormatted() {
    return StringUtils.toMoney(this.getVariable('totalcharge'));
  }

  get chargesSummary() {
    return this.getVariable('chargeSummary');
  }

  get charges() {
    return this.getVariable('charges');
  }

  get terms() {
    return this.getVariable('v-terms');
  }

  get paymentPolicy() {
    return this.getVariable('payment-policy');
  }

  get ccoRecordCreated() {
    return this.getVariable('cco_record_created');
  }

  get noMlsProductOffered() {
    return this.getVariable('no_mls_product_offered');
  }

  get civicApiKey() {
    return this.getVariable('civic_api_key');
  }

  getVariable(variableName: string) {
    return this.surveyService.surveyModel.getVariable(variableName);
  }

  setVariable(variableName: string, value: any) {
    this.surveyService.surveyModel.setVariable(variableName, value);
  }
}
